import React from 'react'
import { Typography } from '@mui/material'
import { StatusChipV4 } from '@labrav/react-components'
import { SubscriptionDetailObject } from '../../../../modules/subscription/reducer'

export type ContractPdfDownloadButtonProps = {
  partnerId: string
  entityId: string
}

interface OfferHeaderProps {
  offerDetailInfo: {
    offerName?: string
  }
  subscriptionDetail: SubscriptionDetailObject
  isCPPOSubscription: boolean
  isCPViewSubscription: boolean
  isISVViewSubsbcription: boolean
  subscriptionsId: string
  classes: any
  cloudType: string
  partnerId?: string
  ContractPdfDownloadButton?: React.ComponentType<ContractPdfDownloadButtonProps>
}

export const OfferHeader: React.FC<OfferHeaderProps> = ({
  offerDetailInfo,
  subscriptionDetail,
  isCPPOSubscription,
  classes,
  cloudType,
  subscriptionsId,
  partnerId = '',
  ContractPdfDownloadButton,
}) => {
  return (
    <div className={classes.offerHeader}>
      <div className={classes.offerHeaderLeft}>
        <div className={classes.offerLabel}>
          <Typography variant="caption" className={classes.offerLabelText}>
            {(
              subscriptionDetail?.subscription?.offerType || ''
            ).toUpperCase() !== 'PUBLIC'
              ? 'Offer'
              : 'Product'}
          </Typography>
        </div>
        <div className={classes.offerNameContainer}>
          <Typography variant="h6" className={classes.offerName}>
            {(
              subscriptionDetail?.subscription?.offerType || ''
            ).toUpperCase() !== 'PUBLIC'
              ? offerDetailInfo?.offerName
              : subscriptionDetail.productDetails.productName
                ? subscriptionDetail.productDetails.productName
                : '-'}
          </Typography>
          {(subscriptionDetail.offerDetails.type === 'RENEWAL' ||
            subscriptionDetail.cppoDetails?.type === 'RENEWAL') && (
            <StatusChipV4 label="ABO" variant="default" size="small" />
          )}
          {isCPPOSubscription ? (
            <StatusChipV4
              label="Channel offer"
              variant="default"
              size="small"
            />
          ) : (
              subscriptionDetail?.subscription?.offerType || ''
            ).toUpperCase() === 'PRIVATE' ? (
            <StatusChipV4 label="Private offer" variant="default" />
          ) : (
              subscriptionDetail?.subscription?.offerType || ''
            ).toUpperCase() === 'PUBLIC' ? (
            <StatusChipV4 label="Public offer" variant="default" />
          ) : (
            <></>
          )}
        </div>
      </div>
      {cloudType === 'AWS' && partnerId && ContractPdfDownloadButton && (
        <div className={classes.offerHeaderRight}>
          <ContractPdfDownloadButton
            partnerId={partnerId}
            entityId={subscriptionsId}
          />
        </div>
      )}
    </div>
  )
}
